// @ts-strict

import { Component, Input } from '@angular/core';
import { NotificationTypes, NotificationType } from '@app/core/services/global-notifications/global-notifications.model';
import { GlobalNotificationsService } from '@app/core/services/global-notifications/global-notifications.service';

@Component({
  selector: 'app-generated-url',
  templateUrl: './generated-url.component.html',
  styleUrls: ['./generated-url.component.scss']
})
export class GeneratedUrlComponent {
  @Input() generatedURL: string = '';

  constructor(private globalNotificationsService: GlobalNotificationsService) {}

  public async copyInputMessage(inputElement: HTMLInputElement): Promise<void> {
    try {
      navigator.clipboard.writeText(inputElement.value);
      this.showNotification('view_translations.link_copied', NotificationTypes[3]);
    } catch {
      this.showNotification('view_translations.error_occured_while_copying_link', NotificationTypes[1]);
    }
  }

  private showNotification(message: string, type: NotificationType): void {
    this.globalNotificationsService.show({
      message,
      type,
      translate: true,
      isPersistent: false,
      id: ''
    });
  }
}
